import type { TFunction } from 'i18next'

/**
 * Format category list for display (categories are lowercase from backend, e.g. ["industrial", "residential"]).
 * Uses translation for category names, connectors, and suffix.
 */
export function formatCategoriesForDisplay(categories: string[], t: TFunction): string {
  if (categories.length === 0) return ''
  const suffix = t('building.suffix')
  const and = t('building.and')
  const commaAnd = t('building.commaAnd')
  const translated = categories.map((c) => {
    const key = c.charAt(0).toUpperCase() + c.slice(1).toLowerCase()
    return t(`building.categories.${key}`)
  })
  if (categories.length === 1) return `${translated[0]}${suffix}`
  if (categories.length === 2) return `${translated[0]}${and}${translated[1]}${suffix}`
  const last = translated[translated.length - 1]!
  const rest = translated.slice(0, -1).join(', ')
  return `${rest}${commaAnd}${last}${suffix}`
}
